import styled, { css } from 'styled-components';

import {
  LANDING_BREAKPOINT,
  LANDING_BREAKPOINT_VALUE,
} from '@utils/theme/breakPoint';
import Button from '@components/Button';

export const HeroCampaignBannerContainer = styled.div`
  width: 100%;
  height: 100%;
  @media (min-width: ${LANDING_BREAKPOINT}) {
    margin: 0 auto;
    padding: 0;
  }
`;

export const ImageWrapper = styled.div<{ noBg: boolean }>`
  @media (min-width: ${LANDING_BREAKPOINT}) {
    height: ${(p) => (p.noBg ? '220px' : '100%')};
    width: 100%;
  }
  height: 100%;
  position: relative;
  box-shadow: ${(p) =>
    p.noBg ? 'unset' : '0 20px 40px 0 rgba(76, 139, 191, 0.2);'};
  background: ${(p) => (p.noBg ? p.theme.palette.athensGray : 'unset')};
`;

export const FadeOutLayout = styled.div`
  @media (min-width: ${LANDING_BREAKPOINT}) {
    display: none;
  }
  @media (max-width: ${LANDING_BREAKPOINT_VALUE - 1}) {
    background-color: rgba(255, 255, 255, 0.48);
    z-index: 2;
  }
`;

export const CampaignDetailsButton = styled(Button)`
  width: 260px;
  height: 58px;
  margin: 30px 0 0;
  padding: 17px 25px 18px 26px;
  border-radius: 2px;
  box-shadow: 0 10px 30px 0 rgba(255, 65, 57, 0.5);
  background-color: ${({ theme }) => `${theme.palette.tomato}`};
  display: flex;
  justify-content: center;
  cursor: pointer;
`;

export const CampaignDetailsButtonText = styled.span`
  width: 209px;
  height: 23px;
  font-family: ${({ theme }) => theme.fonts.main};
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${({ theme }) => `${theme.palette.white}`};
`;

export const TextContainer = styled.div<{ noBg: boolean }>`
  position: absolute;
  z-index: 5;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 30px 20px;
  color: ${({ theme }) => `${theme.palette.eclipse}`};
  @media (min-width: ${LANDING_BREAKPOINT}) {
    align-items: initial;
    padding: ${(p) => (p.noBg ? '15px 30px' : '70px 80px')};
  }
`;

export const InfoHeader = styled.div`
  text-align: center;
  @media (min-width: ${LANDING_BREAKPOINT}) {
    text-align: left;
  }
`;

export const MainHeader = styled.div<{ fontSize: number }>`
  font-size: 24px;
  font-weight: 400;
  @media (min-width: ${LANDING_BREAKPOINT}) {
    font-size: ${({ fontSize }) => `${fontSize}px`};
  }
`;

export const SecondHeader = styled.div<{
  bottomMargin: number;
  fontSize: number;
}>`
  margin-bottom: ${({ bottomMargin }) => `${bottomMargin}px`};
  font-weight: bold;
  font-size: 24px;

  @media (min-width: ${LANDING_BREAKPOINT}) {
    font-size: ${({ fontSize }) => `${fontSize}px`};
  }
`;

export const LinkDescWrapper = styled.div<{ noBg: boolean }>`
  display: flex;
  justify-content: flex-end;

  ${(props) =>
    props.noBg &&
    css`
      @media (min-width: ${LANDING_BREAKPOINT}) {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    `}
`;

export const Description = styled.div<{
  fontsize: number;
  bottomMargin: number;
  noBg: boolean;
}>`
  width: calc(100% - 30px);
  font-size: ${(p) => `${p.fontsize}px`};
  text-align: center;
  margin: auto;
  margin-bottom: ${({ bottomMargin }) => `${bottomMargin}px`};
  @media (min-width: ${LANDING_BREAKPOINT}) {
    font-size: ${(p) => `${p.fontsize}px`};
    width: 50%;
    margin: unset;
    text-align: unset;
    margin-bottom: ${({ bottomMargin, noBg }) =>
      !noBg ? `${bottomMargin}px` : '0'};
  }
`;
